import React, { useContext } from "react";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { contentManageRoutes } from "../../ContentRoutes";
import { MovieContext } from "./context/MovieContext";

export const MovieDashboardHeader: React.FunctionComponent = () => {
    const movieContext = useContext(MovieContext);

    const resolveMovieName = (pathPart: string) => {
        if (pathPart === ":movieId") {
            return movieContext.movie.title;
        }
        return undefined;
    };

    return (
        <PageHeader>
            <HeaderBreadcrumb
                routes={contentManageRoutes}
                key={movieContext.movie?.title}
                isLoading={movieContext.isLoading}
                resolveCustomPathText={resolveMovieName}
            />
        </PageHeader>
    );
};
